import clsx from "clsx";
import React from "react";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../common/New-ToolTip";

const QuestionCard = ({
  questionLogo = "",
  questionTitle = () => {},
  question = () => {},
  subquestion = "",
  options = [],
  optionClick = () => {},
  values = [],
  customComponent = () => null,
  buttonComponent = () => null,
  isMulti = false,
  className = "",
}) => {
  return (
    <div className={` ${className}`}>
      <div className="h-[585px] overflow-hidden rounded-[4px] border border-gray-100 flex flex-col">
        <div
          className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
          style={{
            backgroundImage: `url(/icons/texture-background-2.png)`,
          }}
        >
          {questionLogo && (
            <ReactSVG src={questionLogo} className={`w-6 pr-14`} />
          )}
          {questionTitle()}
        </div>
        <div className="flex flex-col gap-5 p-5 overflow-y-auto overflow-x-hidden bg-scroll min-h-[465px]">
          <div className="flex flex-col gap-4">
            {question() !== null && (
              <p className="text-lg t1ext-gray-800 h-[51px]">
                {question()}
                <br />
                {subquestion}
              </p>
            )}
            <div className="flex flex-col gap-2">
              {options.map((option, index) => {
                return isMulti ? (
                  <button
                    key={index}
                    onClick={() => optionClick(option.value)}
                    className={clsx(
                      `text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                      values?.includes(option.value) &&
                        "bg-gray-20 border-gray-600",
                      !values?.includes(option.value) &&
                        "bg-white border-gray-100"
                    )}
                  >
                    <p className="text-body-md text-start whitespace-pre-line flex justify-start items-start">
                      {option.header}
                      {option.tooltipComponent && (
                        <>
                          <ReactSVG
                            src="/icons/information-dark.svg"
                            className="w-5 ml-3"
                            data-tooltip-id="minorCongestion"
                          />
                          <NewToolTip
                            id={"minorCongestion"}
                            render={() => option.tooltipComponent}
                          />
                        </>
                      )}
                    </p>
                    <p className="text-gray-600 text-body-md text-start">
                      {option.subHeader}
                    </p>
                  </button>
                ) : (
                  <button
                    key={index}
                    onClick={() => optionClick(option.value)}
                    className={clsx(
                      `text-body-md p-3 rounded-[4px] border-[1px]
                            text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600`,
                      values === option.value && "bg-gray-20 border-gray-600",
                      values !== option.value && "bg-white border-gray-100"
                    )}
                  >
                    <p className="text-body-md flex justify-start items-start">
                      {option.header}
                    </p>
                    <p className="text-gray-600 text-body-md flex justify-start items-start">
                      {option.subHeader}
                    </p>
                  </button>
                );
              })}
            </div>

            {customComponent()}
          </div>
        </div>
        {buttonComponent()}
      </div>
    </div>
  );
};

export default QuestionCard;
